/**
 * Annual nominal total returns, 1928-2023 (96 years), bundled locally for the
 * historical block bootstrap (spec §14): S&P 500 (incl. dividends), 10-year
 * Treasury total return, and 3-month T-bills.
 *
 * Reproduced from the widely published NYU Stern (Damodaran) annual dataset.
 * Individual years may deviate by small amounts from the canonical file;
 * aggregate moments sanity-checked (equity mean ≈ 11.6%, sd ≈ 19.6%; bond
 * mean ≈ 4.9%; bill mean ≈ 3.3%). Contiguous-block sampling preserves the
 * serial correlation and mean reversion that make sequence-of-returns risk
 * behave as it actually does.
 */
export const HISTORICAL_START_YEAR = 1928;

export const EQUITY_RETURNS = [
  0.4381, -0.083, -0.2512, -0.4384, -0.0864, 0.4998, -0.0119, 0.4674, 0.3194, -0.3534,
  0.2928, -0.011, -0.1067, -0.1277, 0.1917, 0.2506, 0.1903, 0.3582, -0.0843, 0.052,
  0.057, 0.183, 0.3081, 0.2368, 0.1815, -0.0121, 0.5256, 0.326, 0.0744, -0.1046,
  0.4372, 0.1206, 0.0034, 0.2664, -0.0881, 0.2261, 0.1642, 0.124, -0.0997, 0.238,
  0.1081, -0.0824, 0.0356, 0.1422, 0.1876, -0.1431, -0.259, 0.37, 0.2383, -0.0698,
  0.0651, 0.1852, 0.3174, -0.047, 0.2042, 0.2234, 0.0615, 0.3124, 0.1849, 0.0581,
  0.1654, 0.3148, -0.0306, 0.3023, 0.0749, 0.0997, 0.0133, 0.372, 0.2268, 0.331,
  0.2834, 0.2089, -0.0903, -0.1185, -0.2197, 0.2836, 0.1074, 0.0483, 0.1561, 0.0548,
  -0.3655, 0.2594, 0.1482, 0.021, 0.1589, 0.3215, 0.1352, 0.0138, 0.1177, 0.2161,
  -0.0423, 0.3121, 0.1802, 0.2847, -0.1804, 0.2606,
];

export const BOND_RETURNS = [
  0.0084, 0.042, 0.0454, -0.0256, 0.0879, 0.0186, 0.0796, 0.0447, 0.0502, 0.0138,
  0.0421, 0.0441, 0.054, -0.0202, 0.0229, 0.0249, 0.0258, 0.038, 0.0313, 0.0092,
  0.0195, 0.0466, 0.0043, -0.003, 0.0227, 0.0414, 0.0329, -0.0134, -0.0226, 0.068,
  -0.021, -0.0265, 0.1164, 0.0206, 0.0569, 0.0168, 0.0373, 0.0072, 0.0291, -0.0158,
  0.0327, -0.0501, 0.1675, 0.0979, 0.0282, 0.0366, 0.0199, 0.0361, 0.1598, 0.0129,
  -0.0078, 0.0067, -0.0299, 0.082, 0.3281, 0.032, 0.1373, 0.2571, 0.2428, -0.0496,
  0.0822, 0.1769, 0.0624, 0.15, 0.0936, 0.1421, -0.0804, 0.2348, 0.0143, 0.0994,
  0.1492, -0.0825, 0.1666, 0.0557, 0.1512, 0.0038, 0.0449, 0.0287, 0.0196, 0.1021,
  0.201, -0.1112, 0.0846, 0.1604, 0.0297, -0.091, 0.1075, 0.0128, 0.0069, 0.028,
  -0.0002, 0.0964, 0.1133, -0.0442, -0.1783, 0.0388,
];

export const CASH_RETURNS = [
  0.0308, 0.0316, 0.0455, 0.0231, 0.0107, 0.0096, 0.0028, 0.0017, 0.0017, 0.0028,
  0.0007, 0.0005, 0.0004, 0.0013, 0.0034, 0.0038, 0.0038, 0.0038, 0.0038, 0.006,
  0.0105, 0.0112, 0.012, 0.0152, 0.0172, 0.0189, 0.0094, 0.0172, 0.0262, 0.0322,
  0.0177, 0.0339, 0.0288, 0.0235, 0.0277, 0.0316, 0.0355, 0.0395, 0.0486, 0.0431,
  0.0534, 0.0667, 0.0639, 0.0433, 0.0407, 0.0703, 0.0783, 0.0578, 0.0497, 0.0527,
  0.0719, 0.1007, 0.1143, 0.1403, 0.1061, 0.0861, 0.0952, 0.0748, 0.0598, 0.0578,
  0.0667, 0.0811, 0.075, 0.0538, 0.0343, 0.03, 0.0425, 0.0549, 0.0501, 0.0506,
  0.0478, 0.0464, 0.0582, 0.0339, 0.016, 0.0101, 0.0137, 0.0315, 0.0473, 0.0435,
  0.0137, 0.0015, 0.0014, 0.0005, 0.0009, 0.0006, 0.0003, 0.0005, 0.0032, 0.0093,
  0.0194, 0.0206, 0.0035, 0.0005, 0.0202, 0.0507,
];

export const HISTORICAL_YEARS = EQUITY_RETURNS.length;
